module.exports = __webpack_public_path__ + "img/JiFen.87938cff.png";